module.exports = __webpack_public_path__ + "img/瓶中花-1.05363342.jpg";